import {ApolloClient, createHttpLink, InMemoryCache} from "@apollo/client";
import {setContext} from "@apollo/client/link/context";
import {BACKEND_URL} from "./constants";

const httpLink = createHttpLink({
    uri: BACKEND_URL
})

const authLink = setContext((_, {header}) => {
    const token = localStorage.getItem('auth-token-investitum');
    return {
        headers:
            {
                ...header,
                Authorization: `JWT ${token}` || ""
            }
    }

})

const SiteApolloClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    connectToDevTools: true,


    // headers: {
    //     'X-CSRFToken': Cookies.get('csrftoken')
    //  }
});

export default SiteApolloClient;